import palette from 'theme/palette';
import { createStyles } from '@material-ui/styles';

export default () =>
  createStyles({
    titleGrid: {
      margin: 8,
      padding: 8,
      border: `1px solid ${palette.lightGray}`,
      borderRadius: 8,

      '& .MuiTypography-root': {
        fontSize: 14,
      },
    },
    buttonsBase: {
      borderTop: `1px solid ${palette.borderGray}`,
      justifyContent: 'right',
    },
    buttonsAlign: {
      justifyContent: 'flex-end',
      display: 'flex',
      padding: '10px 0px 5px',
    },
  });
